/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import {ChangeEvent, useCallback} from 'react';

/**
 * Defines the useToggleSubGroupChange component. This component is reusable and can be custom
 * rendered with props.
 *
 * ```typescript
 *
 * const onToggleSubGroups = useToggleSubGroupChange(onChecked, onChange);
 * 
 * @param  onChecked object will take precedence when passed as an param.
 * @param  onChange object will take lower precedence over onChecked and 
 *         need to pass checked an boolean param to it.
 *
 * ```
 * 
 */
export const useToggleSubGroupChange = (
  onChecked?: Function,
  onChange?: Function
) => (
  useCallback((e: ChangeEvent<HTMLInputElement>, checked: boolean) => {
    onChecked ? onChecked?.(e?.target?.checked) : onChange?.(e, checked);
  }, [onChecked, onChange])
);

export default useToggleSubGroupChange;
